import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-castemastercreation',
  templateUrl: './castemastercreation.component.html',
  styleUrls: ['./castemastercreation.component.css']
})
export class CastemastercreationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/castemastercreation/castemastercreation.component.ts